import { render, staticRenderFns } from "./WA-SL-Disclosure.vue?vue&type=template&id=01f496a3&scoped=true&"
import script from "./WA-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./WA-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./WA-SL-Disclosure.vue?vue&type=style&index=0&id=01f496a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f496a3",
  null
  
)

export default component.exports